module.exports = __webpack_public_path__ + "assets/Chat_red.15e24954f54f6e055bff62f85e16976a.svg";